/**
 * 公共常量定义
 */

/**
 * 系统级 z-index 配置，比如全局通知消息的 z-index（浏览器支持的最大值通常为 2147483647）
 */
export const SYSTEM_ZINDEX = 2147483600
